import React from "react";
import BottomNavigation from "@material-ui/core/BottomNavigation";
import { withRouter } from "react-router-dom";
import { Typography } from "@material-ui/core";
import { GREY_700, GREY_50 } from "assets/theme/colors";

const Footer = (props) => {
  return (
    <BottomNavigation
      style={{
        width: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: GREY_50,
        height: "50px",
      }}
    >
      <Typography variant="caption" style={{ color: GREY_700 }}>
        Copyright © 2023 VNTRAVEL.,JSC
      </Typography>
    </BottomNavigation>
  );
};

export default withRouter(Footer);
